import { connect } from 'react-redux'
import { Button, AnchorButton, Dialog, DialogBody, DialogFooter, RadioGroup, Radio } from '@blueprintjs/core'
import * as React from 'react'
import { useState } from 'react'
import queryString from 'query-string'
import { AppState } from '../../../store'
import { ConnectedMarket } from '../../../current/types'

interface Props {
  isOpen: boolean
  onClose: () => void
  productId: number
  marketId: number
  connectedMarkets: ConnectedMarket[]
  additionalQueryParams?: {}
}

const CreateListingWhichAccountDialog = ({
  isOpen,
  onClose,
  productId,
  marketId,
  connectedMarkets,
  additionalQueryParams
}: Props) => {
  const [marketAccountId, setMarketAccountId] = useState<number>(null)

  const queryParams = {
    market_id: marketId,
    market_account_id: marketAccountId,
    ...additionalQueryParams
  }

  const href = `/products/${productId}/listings/new?${queryString.stringify(queryParams)}`

  return (
    <Dialog
      title="Which eBay account would you like to list to?"
      isOpen={isOpen}
      onClose={() => {
        onClose()
      }}
    >
      <DialogBody>
        <RadioGroup
          onChange={e => {
            setMarketAccountId(parseInt(e.currentTarget.value))
          }}
          selectedValue={marketAccountId}
        >
          {connectedMarkets
            .filter(
              (connectedMarket: ConnectedMarket) => connectedMarket.marketId === marketId && connectedMarket.onboarded
            )
            .map((connectedMarket: ConnectedMarket) => {
              return (
                <Radio
                  key={connectedMarket.marketAccountId}
                  label={connectedMarket.label}
                  value={connectedMarket.marketAccountId}
                />
              )
            })}
        </RadioGroup>
      </DialogBody>
      <DialogFooter
        actions={
          <>
            <Button minimal onClick={onClose}>
              Cancel
            </Button>
            <AnchorButton disabled={!marketAccountId} intent="primary" href={href}>
              Confirm
            </AnchorButton>
          </>
        }
      />
    </Dialog>
  )
}

export default connect((s: AppState) => ({
  connectedMarkets: s.current.organization.connectedMarkets
}))(CreateListingWhichAccountDialog)
